module.exports = __webpack_public_path__ + "img/center-intro-structure1-1.2d9de42d.png";